export default __webpack_public_path__ + "static/media/wowPoster.d2d0e8db.jpg";